import { render, staticRenderFns } from "./InternetDeclaration.vue?vue&type=template&id=2cdd6a25&"
import script from "./InternetDeclaration.vue?vue&type=script&lang=js&"
export * from "./InternetDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./InternetDeclaration.vue?vue&type=style&index=1&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports